import React from "react";
import "../styles/services-page.css";

const futureDesignerSessions = [
  {
    part: "PHẦN 1: THIẾT KẾ QUẢNG CÁO VỚI CANVA (Buổi 1–6)",
    sessions: [
      {
        title: "Buổi 1: Giới thiệu nghề thiết kế và Canva",
        items: ["Nghề thiết kế là gì?", "Làm quen với Canva"],
        goal: "Truyền cảm hứng và giúp học sinh hiểu cơ bản về thiết kế",
      },
      {
        title: "Buổi 2: Bố cục & màu sắc trong thiết kế",
        items: ["Quy tắc bố cục cơ bản", "Chọn màu và font chữ phù hợp"],
        goal: "Biết cách sắp xếp nội dung trực quan và thẩm mỹ",
      },
      {
        title: "Buổi 3: Thiết kế poster quảng cáo sản phẩm",
        items: ["Chọn sản phẩm yêu thích", "Tạo poster bằng Canva"],
        goal: "Thực hành sáng tạo áp phích truyền thông sản phẩm",
      },
      {
        title: "Buổi 4: Thiết kế bài đăng mạng xã hội",
        items: ["Instagram/Facebook post", "Mẹo làm nội dung thu hút"],
        goal: "Làm quen với xu hướng thiết kế số",
      },
      {
        title: "Buổi 5: Thiết kế banner và infographic",
        items: ["Phân biệt banner và infographic", "Làm infographic đơn giản"],
        goal: "Kết hợp thông tin và hình ảnh hiệu quả",
      },
      {
        title: "Buổi 6: Thực hành & phản hồi",
        items: ["Học sinh trình bày sản phẩm", "Nhận góp ý và hoàn thiện"],
        goal: "Rèn kỹ năng trình bày và chỉnh sửa",
      },
    ],
  },
  {
    part: "PHẦN 2: QUAY PHIM VỚI ĐIỆN THOẠI (Buổi 7–10)",
    sessions: [
      {
        title: "Buổi 7: Giới thiệu quay phim cơ bản",
        items: ["Kỹ thuật cầm máy, ánh sáng, bố cục khung hình"],
        goal: "Nắm nguyên tắc cơ bản khi quay video",
      },
      {
        title: "Buổi 8: Kịch bản & dàn dựng cảnh quay",
        items: ["Viết ý tưởng ngắn", "Dàn cảnh cho video quảng cáo"],
        goal: "Học cách kể chuyện và xây dựng nội dung",
      },
      {
        title: "Buổi 9: Quay thực tế",
        items: ["Tổ chức quay video nhóm nhỏ"],
        goal: "Áp dụng lý thuyết vào thực hành",
      },
      {
        title: "Buổi 10: Nhạc nền, ghi âm thoại, chèn hiệu ứng",
        items: ["Âm thanh & hiệu ứng khi quay"],
        goal: "Làm phong phú nội dung quay bằng âm thanh và hiệu ứng",
      },
    ],
  },
  {
    part: "PHẦN 3: DỰNG PHIM & TRÌNH BÀY SẢN PHẨM (Buổi 11–15)",
    sessions: [
      {
        title: "Buổi 11: Giới thiệu ứng dụng dựng phim",
        items: ["Làm quen với CapCut/InShot"],
        goal: "Biết cách dựng video đơn giản",
      },
      {
        title: "Buổi 12: Cắt ghép – Hiệu ứng – Lồng nhạc",
        items: ["Chỉnh sửa video cơ bản"],
        goal: "Nắm được kỹ thuật chỉnh sửa video cơ bản",
      },
      {
        title: "Buổi 13: Làm phụ đề – Intro/Outro",
        items: ["Tạo phong cách riêng cho video"],
        goal: "Tạo phong cách riêng cho video",
      },
      {
        title: "Buổi 14: Hoàn thiện video – Thumbnail",
        items: ["Kết hợp Canva và video thành sản phẩm hoàn chỉnh"],
        goal: "Kết hợp thiết kế và dựng phim thành sản phẩm hoàn chỉnh",
      },
      {
        title: "Buổi 15: Trình chiếu sản phẩm – Nhận xét – Chứng nhận",
        items: ["Trình bày và nhận góp ý"],
        goal: "Tự tin trình bày, chia sẻ và nhận đánh giá từ giáo viên, bạn bè",
      },
    ],
  },
];

const extras = [
  "🎨 Biết thiết kế poster, banner, bài đăng mạng xã hội với Canva",
  "📽️ Tự viết kịch bản, quay phim và dựng video bằng điện thoại",
  "🖼️ Có sản phẩm thiết kế quảng cáo và video hoàn chỉnh",
  "💡 Rèn luyện tư duy sáng tạo, làm việc nhóm và thuyết trình",
  "🏅 Nhận giấy chứng nhận hoàn thành khóa học “Nhà Thiết Kế Tương Lai”",
];
const isOdd = extras.length % 2 !== 0;

const ServicesPage = () => {
  return (
    <div className="services-page-bg">
      <div className="services-page">
        <h1 className="services-page__title">NHÀ THIẾT KẾ TƯƠNG LAI</h1>
        <p className="services-page__desc">
          Khóa học dành cho học sinh cấp 1 và cấp 2, giúp phát triển tư duy
          thiết kế, kỹ năng quay dựng video và khả năng trình bày ý tưởng một
          cách chuyên nghiệp.
        </p>
        <p className="services-page__meta">
          ⏱️ Thời lượng: 15 buổi (mỗi buổi 2 giờ) — Công cụ: Canva, điện thoại
          thông minh, CapCut/InShot/Kinemaster
        </p>
        <div className="services-page__extras">
          <h2 className="services-page__extras-title">Mục tiêu khóa học</h2>
          <ul
            className={`services-page__extras-list ${
              isOdd ? "center-last" : ""
            }`}
          >
            {extras.map((item, idx) => (
              <li key={idx}>
                <span className="emoji">{item.split(" ")[0]}</span>
                {item.slice(2)}
              </li>
            ))}
          </ul>
        </div>
        {futureDesignerSessions.map((section, idx) => (
          <div key={idx}>
            <h2 className="services-page__section-title">{section.part}</h2>
            <div className="services-page__sessions">
              {section.sessions.map((session, i) => (
                <div
                  className="services-page__session"
                  key={i}
                >
                  <h3 className="services-page__session-title">
                    {session.title}
                  </h3>
                  <ul className="services-page__session-list">
                    {session.items.map((item, j) => (
                      <li
                        className="services-page__session-item"
                        key={j}
                      >
                        <span className="services-page__icon">✅</span> {item}
                      </li>
                    ))}
                  </ul>
                  {session.goal && (
                    <p className="services-page__session-goal">
                      🎯 <strong>Mục tiêu:</strong> {session.goal}
                    </p>
                  )}
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ServicesPage;
